// Centralized human-readable labels for enums.
// Single source of truth — pages must import these, not redefine them.

import type { JobStatus, JobType, CustomerType, TrackingLevel } from '@gutterinv/shared';

export const STATUS_LABEL: Record<JobStatus, string> = {
  created: 'Created',
  estimated: 'Estimated',
  quoted: 'Quoted',
  accepted: 'Accepted',
  scheduled: 'Scheduled',
  installed: 'Installed',
  invoiced: 'Invoiced',
  completed: 'Completed',
  disqualified: 'Disqualified',
};

export const JOB_TYPE_LABEL: Record<JobType, string> = {
  new_work: 'New Work',
  repair: 'Repair',
  warranty: 'Warranty',
};

export const CUSTOMER_TYPE_LABEL: Record<CustomerType, string> = {
  residential: 'Residential',
  builder: 'Builder',
  commercial: 'Commercial',
};

export const TRACKING_LEVEL_LABEL: Record<TrackingLevel, string> = {
  rigorous: 'Rigorous',
  loose: 'Loose',
};
